import { render, staticRenderFns } from "./WalletDetail.vue?vue&type=template&id=f21e4394"
import script from "./WalletDetail.vue?vue&type=script&lang=ts"
export * from "./WalletDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports